import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, Typography } from 'antd';
import { Result as MobileResult, Button as MobileButton } from 'antd-mobile';
import { CheckOutlined } from '@ant-design/icons';
import { getSizeInfo } from '../../data/sizeReference';
import { useIsMobile } from '../../hooks/useMediaQuery';
import styles from './Success.module.css';

const { Text } = Typography;

export default function SuccessPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();

  const name = location.state?.name || '同事';
  const size = location.state?.size || 'L';
  const sizeInfo = getSizeInfo(size);

  if (isMobile) {
    return (
      <section className={`card ${styles.successMobile}`}>
        <MobileResult
          status="success"
          title="福利工装申领成功"
          description={
            <div className={styles.descMobile}>
              <p><strong>{name}</strong>，您的企业工装福利申领已提交。</p>
              <p>所选尺码：<strong>{size}</strong>（{sizeInfo.friendlyName}）</p>
              <p className={styles.hint}>乐福集采将统一采购，发放时间另行通知，请耐心等待。</p>
            </div>
          }
        />
        <div className={styles.actionsMobile}>
          <MobileButton block color="primary" size="large" onClick={() => navigate('/apply')} className={styles.actionBtn}>
            继续申领
          </MobileButton>
          <MobileButton block fill="outline" size="large" onClick={() => navigate('/')} className={styles.actionBtn}>
            返回首页
          </MobileButton>
        </div>
      </section>
    );
  }

  return (
    <section className={`card ${styles.success}`}>
      <div className={styles.successCard}>
        <div className={styles.iconWrap}>
          <CheckOutlined style={{ fontSize: 28, color: '#165dff' }} />
        </div>
        <h2 className={styles.title}>福利工装申领成功</h2>
        <div className={styles.subtitle}>
          <p><Text strong>{name}</Text>，您的企业工装福利申领已提交。</p>
          <p>所选尺码：<Text strong>{size}</Text>（{sizeInfo.friendlyName}）</p>
          <p className={styles.hint}>乐福集采将统一采购并安排发放，请耐心等待。</p>
        </div>
        <div className={styles.actions}>
          <Button type="primary" size="large" onClick={() => navigate('/apply')}>继续申领</Button>
          <Button size="large" onClick={() => navigate('/')}>返回首页</Button>
        </div>
      </div>
    </section>
  );
}
